import * as F from "fp-ts/function"

export const trimStart = (value: string) => (path: string) => path.replace(new RegExp(`^\\${value}+`), "")
export const trimEnd = (value: string) => (path: string) => path.replace(new RegExp(`\\${value}+$`), "")
export const trim = (value: string) => (path: string) => F.pipe(path, trimStart(value), trimEnd(value))
export const NON_BREAKING_SPACE = "\u00a0"

export function snakeCase(string: undefined): undefined
export function snakeCase(string: string): string
export function snakeCase(string: string | undefined): string | undefined {
    if (!string) return undefined

    return string
        .trim()
        .toLowerCase()
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        ?.join("_")
}

export function stringPresent(content: string | null | undefined): content is string {
    if (content == null || content == undefined) return false

    return content.trim() != ""
}

export const randomString = () => Math.random().toString(36).slice(2, 10)
